/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Invite_InvalidInputs */

const nl_invite_errors_invite_invalid = /** @type {(inputs: Invite_Errors_Invite_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze uitnodiging is ongeldig. Controleer of je de juiste link hebt gebruikt.`)
};

/**

* @param {Invite_Errors_Invite_InvalidInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_invite_invalid = /** @type {((inputs?: Invite_Errors_Invite_InvalidInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Invite_InvalidInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_invite_invalid(inputs)
});
export { invite_errors_invite_invalid as "invite.errors.invite_invalid" }